import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

window.addEventListener(
  "error",
  (event) => {
    if (event.message === "Script error." && !event.filename && !event.lineno && !event.colno) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true,
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason = event.reason;
    if (reason?.message === "Script error." || reason === "Script error.") {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true,
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
